module.exports = __webpack_public_path__ + "static/img/pos_qrcode.b87f188.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/pos_qrcode.png
// module id = WIx0
// module chunks = 8